import { render, staticRenderFns } from "./HansgroheLogo.vue?vue&type=template&id=70aa0fb4&scoped=true&"
var script = {}
import style0 from "./HansgroheLogo.vue?vue&type=style&index=0&id=70aa0fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa0fb4",
  null
  
)

export default component.exports